import React, { useState } from 'react'
import Progress from './progress'

export default Component => {
    const PickerSourceDrop = ({
        onLink, //async optional
        onFile, //async optional
        onCustom, //async optional (type, data)
        validateCustom, //func optional (type)
        ...etc
    }) => {
        const [files, setFiles] = useState([])
        const [filesDone, setFilesDone] = useState(false)
        const [links, setLinks] = useState([])
        const [custom, setCustom] = useState([])

        return (
            <>
                <Component
                    {...etc}
                    onLink={onLink}
                    onFile={onFile}
                    onCustom={onCustom}
                    validateCustom={validateCustom}
                    files={files}
                    filesDone={filesDone}
                    onDropFiles={(files = []) => {
                        setFiles(files)
                        setFilesDone(false)
                    }}
                    onDropLinks={setLinks}
                    onDropCustom={setCustom}
                />

                <Progress
                    items={files}
                    getName={(file = {}) => file.name || ''}
                    process={onFile}
                    onDone={() => setFilesDone(true)}
                    onCancel={() => setFiles([])}
                />

                <Progress
                    items={links}
                    getName={(link) => link}
                    process={onLink}
                    onCancel={() => setLinks([])}
                />

                <Progress
                    items={custom}
                    getName={(custom) => custom[1]}
                    process={onCustom}
                    onCancel={() => setCustom([])}
                />
            </>
        )
    }

    PickerSourceDrop.displayName = `PickerSourceDrop(${
        Component.displayName || Component.name || 'Component'
    })`

    return PickerSourceDrop
}
